





















import merge from "../utils/merge";
import defaultComponent from "../utils/defaultComponent";

export default defaultComponent.apply({
  props: [],
  data() {
    return {
      contentHTML: "",
    };
  },
  watch: {
    model: {
      handler(val) {
        if (val && val.value) {
          this.updateContext();
        } else if (val) {
          this.error.value = "";
          this.$emit("close");
        }
      },
      deep: true,
    },
    error: {
      handler(val) {
        if (val && val.value) {
          this.model.value = true;
        }
        // console.log(val && val.value);
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      if (
        this.options.content.template.button &&
        !this.options.content.template.button.disabled
      ) {
        this.options.content.template.button = merge.clone(
          this.$vuetifyx.notifySnackBar.content.template.button,
          this.options.content.template.button
        );
      }
      if (this.error.value) {
        this.model.value = true;
      }
      this.updateContext();
    },
    updateContext() {
      if (this.error && this.error.value) {
        this.contentHTML = this.error.value;
        return;
      }
      switch (typeof this.options.content.content.html) {
        case "function":
          this.contentHTML = this.options.content.content.html(this);
          break;
        default:
          this.contentHTML = this.options.content.content.html;
      }
    },
    show() {
      this.model.value = true;
    },
    hide() {
      this.model.value = false;
    },
  },
  extraOptions: {
    forwardStates: {
      xModel: ["model", false],
      xError: ["error"],
    },
    defaultClass: "notifySnackBar",
  },
});
